import { gql as e } from "@apollo/client";
const t = e`
  mutation SendBelieveInviter($id: String!, $code: String!, $address: String!) {
    updateCampaignInvitee(
      input: {
        campaignID: $id
        invitationCode: $code
        inviteeWalletAddress: $address
      }
    )
  }
`;
export {
  t as default
};
//# sourceMappingURL=sendBelieveInviter.js.map
